var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#061833"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 340L25 357.5C50 375 100 410 150 414C200 418 250 391 300 388.8C350 386.7 400 409.3 450 404.5C500 399.7 550 367.3 600 361.7C650 356 700 377 750 384.7C800 392.3 850 386.7 875 383.8L900 381L900 601L875 601C850 601 800 601 750 601C700 601 650 601 600 601C550 601 500 601 450 601C400 601 350 601 300 601C250 601 200 601 150 601C100 601 50 601 25 601L0 601Z",
    fill: "#fa7268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 477L25 470.2C50 463.3 100 449.7 150 436.5C200 423.3 250 410.7 300 416.5C350 422.3 400 446.7 450 454.8C500 463 550 455 600 454.8C650 454.7 700 462.3 750 461.8C800 461.3 850 452.7 875 448.3L900 444L900 601L875 601C850 601 800 601 750 601C700 601 650 601 600 601C550 601 500 601 450 601C400 601 350 601 300 601C250 601 200 601 150 601C100 601 50 601 25 601L0 601Z",
    fill: "#f16359"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 474L25 468.8C50 463.7 100 453.3 150 460.8C200 468.3 250 493.7 300 495.7C350 497.7 400 476.3 450 461.3C500 446.3 550 437.7 600 442.5C650 447.3 700 465.7 750 471.8C800 478 850 472 875 469L900 466L900 601L875 601C850 601 800 601 750 601C700 601 650 601 600 601C550 601 500 601 450 601C400 601 350 601 300 601C250 601 200 601 150 601C100 601 50 601 25 601L0 601Z",
    fill: "#e7534b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 474L25 477.8C50 481.7 100 489.3 150 500.2C200 511 250 525 300 527.8C350 530.7 400 522.3 450 524.3C500 526.3 550 538.7 600 544.2C650 549.7 700 548.3 750 546.8C800 545.3 850 543.7 875 542.8L900 542L900 601L875 601C850 601 800 601 750 601C700 601 650 601 600 601C550 601 500 601 450 601C400 601 350 601 300 601C250 601 200 601 150 601C100 601 50 601 25 601L0 601Z",
    fill: "#dd423d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 527L25 536.2C50 545.3 100 563.7 150 569.2C200 574.7 250 567.3 300 563.5C350 559.7 400 559.3 450 553.5C500 547.7 550 536.3 600 530C650 523.7 700 522.3 750 532C800 541.7 850 562.3 875 572.7L900 583L900 601L875 601C850 601 800 601 750 601C700 601 650 601 600 601C550 601 500 601 450 601C400 601 350 601 300 601C250 601 200 601 150 601C100 601 50 601 25 601L0 601Z",
    fill: "#d32f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.642c8a1a0891a36e8dc11587bf3f5b81.svg";
export { ForwardRef as ReactComponent };